<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
        </div>
        <NevsCard class="form">
            <NevsTextField readonly class="half" v-model="client.name" :error="clientValidation.name"
                           :label="'*' + $LANG.Get('fields.name') + ':'"></NevsTextField>
            <NevsTextField readonly class="half" v-model="client.oib" :error="clientValidation.oib"
                           :label="'*' + $LANG.Get('fields.oib') + ':'"></NevsTextField>
            <NevsTextField v-model="client.sport_center_name" :error="clientValidation.sport_center_name"
                           :label="$LANG.Get('fields.sportCenterName') + ':'"></NevsTextField>
            <NevsTextField class="half" v-model="client.iban" :error="clientValidation.iban"
                           :label="$LANG.Get('fields.iban') + ':'"></NevsTextField>
            <NevsTextField class="half" v-model="client.swift" :error="clientValidation.swift"
                           :label="$LANG.Get('fields.swift') + ':'"></NevsTextField>
            <NevsTextField v-model="client.address" :error="clientValidation.address"
                           :label="'*' + $LANG.Get('fields.streetAndHouseNo') + ':'"></NevsTextField>
            <NevsTextField class="half" v-model="client.postal_code" :error="clientValidation.postal_code"
                           :label="'*' + $LANG.Get('fields.postalCode') + ':'"></NevsTextField>
            <NevsTextField class="half" v-model="client.city" :error="clientValidation.city"
                           :label="'*' + $LANG.Get('fields.city') + ':'"></NevsTextField>
            <NevsTextField v-model="client.country" :error="clientValidation.country"
                           :label="'*' + $LANG.Get('fields.country') + ':'"></NevsTextField>
            <NevsCheckbox v-model="client.tax_system" :label="$LANG.Get('fields.taxSystem')"></NevsCheckbox>
            <NevsUpload :accept="'image/png'" v-model="client.logo"
                        :label="$LANG.Get('fields.logo') + ':'"></NevsUpload>
            <img v-if="client.logo && client.logo.link" :src="client.logo.link" class="logo-preview" alt=""/>
        </NevsCard>
    </div>
</template>

<script>
import Client from "@/models/Client.js";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsUpload from "@/components/nevs/NevsUpload.vue";

export default {
    name: "GeneralData",
    components: {NevsUpload, NevsCheckbox, NevsCard, NevsTextField, NevsButton},
    data() {
        return {
            loaded: false,
            client: new Client(),
            clientValidation: new Client({}, true)
        }
    },
    methods: {
        saveClick() {
            let valid = true;

            if (this.client.name === '') {
                valid = false;
                this.clientValidation.name = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.clientValidation.name = '';
            }

            if (this.client.oib !== '') {
                if (!this.$HELPERS.CheckOIB(this.client.oib)) {
                    valid = false;
                    this.clientValidation.oib = this.$LANG.Get('labels.invalidOIB');
                } else {
                    this.clientValidation.oib = '';
                }
            } else {
                valid = false;
                this.clientValidation.oib = this.$LANG.Get('labels.mandatoryField');
            }

            if (this.client.address === '') {
                valid = false;
                this.clientValidation.address = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.clientValidation.address = '';
            }

            if (this.client.postal_code === '') {
                valid = false;
                this.clientValidation.postal_code = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.clientValidation.postal_code = '';
            }

            if (this.client.city === '') {
                valid = false;
                this.clientValidation.city = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.clientValidation.city = '';
            }

            if (this.client.country === '') {
                valid = false;
                this.clientValidation.country = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.clientValidation.country = '';
            }

            if (valid) {
                let vm = this;
                this.$API.APICall('put', 'client', this.client, (data, success) => {
                    if (success) {
                        vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                        vm.$API.APICall('get', 'session', {}, (data, success) => {
                            if (success) {
                                vm.$store.commit('setUser', data.user);
                            }
                        }, false);
                    } else if (data.error !== undefined && data.error === 'duplicate oib') {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: vm.$LANG.Get('alerts.clientOibDuplicate'),
                            type: 'alert'
                        });
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                })
            }
        }
    },
    mounted() {

        if (!this.$store.state.user.permissions.includes('ADMINISTRATOR')) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }
        this.$store.commit('selectMenu', 'settings');
        this.$store.commit('selectSubMenu', 'generalData');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.settings'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.generalData'),
                link: null
            }
        ]);

        let vm = this;
        this.$API.APICall('get', 'client', {}, (data, success) => {
            if (success) {
                if (data.client !== null) {
                    vm.client.Fill(data.client);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            } else {
                vm.$HELPERS.HandleServerError(vm, data);
            }
            vm.$nextTick(() => {
                vm.loaded = true;
            });
        });
    }
}
</script>

<style scoped>
.form {
    max-width: 600px;
}

/* Preview of the uploaded logo: constrained on both axes so any uploaded image scales to fit. */
.logo-preview {
    display: block;
    max-width: 100%;
    max-height: 160px;
    width: auto;
    height: auto;
    object-fit: contain;
    margin-top: 10px;
}

.half {
    width: 50% !important;
}

@media only screen and (max-width: 600px) {
    .half {
        width: 100% !important;
    }
}

</style>